import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';

import { AuthLayout } from '@/components/layout/auth-layout';
import { FullPageSpinner } from '@/components/shared/spinner/full-page-spinner';
import { LoginPage } from '@/modules/auth/pages/login';

export const GuestApp = () => {
  const router = createBrowserRouter([
    {
      path: 'auth/*',
      element: <AuthLayout />,
      HydrateFallback: FullPageSpinner,
      children: [
        { path: 'login', element: <LoginPage /> },
        { path: '*', element: <Navigate to="/auth/login" /> },
      ],
    },
    { path: '*', element: <Navigate to="/auth/login" /> },
  ]);

  return <RouterProvider router={router} />;
};
